import createDOMProps from '../createDOMProps';
import findNodeHandle from '../../exports/findNodeHandle';
import styleResolver from '../../exports/StyleSheet/styleResolver';
import UIManager from '../../exports/UIManager';
var NativeMethodsMixin = {
  blur: function blur() {
    UIManager.blur(findNodeHandle(this));
  },
  focus: function focus() {
    UIManager.focus(findNodeHandle(this));
  },
  measure: function measure(callback) {
    UIManager.measure(findNodeHandle(this), callback);
  },
  measureInWindow: function measureInWindow(callback) {
    UIManager.measureInWindow(findNodeHandle(this), callback);
  },
  measureLayout: function measureLayout(relativeToNativeNode, onSuccess, onFail) {
    UIManager.measureLayout(findNodeHandle(this), relativeToNativeNode, onFail, onSuccess);
  },
  setNativeProps: function setNativeProps(nativeProps) {
    if (!nativeProps) {
      return;
    }

    var node = findNodeHandle(this);

    if (node) {
      var domProps = createDOMProps(null, nativeProps, function (style) {
        return styleResolver.resolveWithNode(style, node);
      });
      UIManager.updateView(node, domProps, this);
    }
  }
};
export default NativeMethodsMixin;